import React from "react";
import "./BrandFilms.css";
import greyHeronImage from "../../assets/BrandFlims/GreyHeron.png";
import kaamnaImage1 from "../../assets/BrandFlims/KaamnaFocus.jpg";
import kaamnaImage2 from "../../assets/BrandFlims/KaamnaB&W.jpg";
import kaamnaImage3 from "../../assets/BrandFlims/KaamnaRenovate.jpg";
import NikronImage from "../../assets/BrandFlims/Nikron.png";
const brandFilmGroups = [
  {
    title: "GREY HERON",

    description:
      "Capturing the discipline, grit, and style behind every workout.",

    note:
      "The brand is built for performance. I'm built for post-workout snacks.",

    layout: "featured",

    items: [
      {
        title: "MOVE WITH PURPOSE",
        category: "BRAND FILM",
        image: greyHeronImage,
      },
    ],
  },

  {
    title: "KAAMNA",

    description:
      "Luxury accessories where craftsmanship meets quiet confidence.",

    note:
      "My wallet has never looked this expensive. Mostly because it's empty.",

    layout: "grid",

    items: [
      {
        title: "KAAMNA FOCUS",
        category: "BRAND FILM",
        image: kaamnaImage1,
      },
      {
        title: "KAAMNA BLACK & WHITE",
        category: "BRAND FILM",
        image: kaamnaImage2,
      },
      {
        title: "KAAMNA RENOVATE",
        category: "BRAND FILM",
        image: kaamnaImage3,
      },
    ],
  },

  {
    title: "NIKRON",

    description:
      "Modern sneakers inspired by street culture and self-expression.",

    note:
      "These sneakers can't fix your life. Mine are still trying.",

    layout: "featured",

    items: [
      {
        title: "STREET SMART STREETWEAR",
        category: "BRAND FILM",
        image: NikronImage,
      },
    ],
  },
];


const categories = [
  "CAMPAIGNS",
  "COMMERCIALS",
  "BRAND FILMS",
  "CORPORATE FILMS",
  "DOCUMENTARIES",
  "PODCASTS & INTERVIEWS",
  "EVENTS",
  "SOCIAL AND VERTICAL FILMS",
  "PHOTOGRAPHY CREATIVE",
];


function pad(num) {
  return String(num).padStart(2, "0");
}


function BrandFilms() {

  const goToCategory = (category) => {
    const routes = {
        "CAMPAIGNS": "/campaigns",
        "COMMERCIALS": "/commercials",
        "BRAND FILMS": "/brand-films",
        "CORPORATE FILMS": "/corporate-films",
        "DOCUMENTARIES": "/documentaries",
        "PODCASTS & INTERVIEWS": "/podcasts",
    };

    const route = routes[category];

    if (route) {
        window.location.href = route;
    }
};


  return (
    <main className="campaign-page brand-films-page">

      <div className="campaign-shell">

        <div className="campaign-content">

          {/* =====================================
              MAIN PAGE HEADER
          ===================================== */}

          <header className="brand-main-header">

            <h1 className="brand-main-title">
              BRAND FILMS
            </h1>

            <div className="brand-main-rule">
              <span>VISUAL STORIES · BRAND WORLDS</span>
            </div>

          </header>


          {/* =====================================
              BRAND FILM GROUPS
          ===================================== */}

          {brandFilmGroups.map((group, groupIndex) => (

            <section
              className={`brand-group brand-${group.layout}`}
              key={group.title}
            >

              {/* GROUP TITLE */}

              <div className="brand-group-heading">

  <div className="brand-group-number">
    {pad(groupIndex + 1)}
  </div>

  <div className="brand-group-title-wrap">

    <span className="brand-group-label">
      BRAND STORY
    </span>

    <h2>
      {group.title}
    </h2>

  </div>

  <div className="brand-group-line"></div>

</div>


<div className="brand-group-copy">

  <p className="brand-group-description">
    {group.description}
  </p>

  <p className="brand-group-note">
    {group.note}
  </p>

</div>


              {/* =================================
                  FEATURED / GRID
              ================================= */}

              <div className="brand-film-grid">

                {group.items.map((item, itemIndex) => (

                  <article
                    className="campaign-card brand-film-card"
                    key={item.title}
                    tabIndex={0}
                  >

                    {/* INDEX */}

                    <div className="campaign-card-index">

                      {pad(itemIndex + 1)}

                      <span>
                        /{pad(group.items.length)}
                      </span>

                    </div>


                    {/* IMAGE */}

                    <img
                      src={item.image}
                      alt={item.title}
                      className="campaign-card-image"
                    />


                    {/* OVERLAY */}

                    <div className="campaign-card-overlay"></div>


                    {/* VIEWFINDER FRAME */}

                    <div className="campaign-card-frame">

                      <span></span>
                      <span></span>
                      <span></span>
                      <span></span>

                    </div>


                    {/* PLAY */}

                    <button
                      type="button"
                      className="campaign-play"
                      aria-label={`Play ${item.title}`}
                    >
                      <span></span>
                    </button>


                    {/* CONTENT */}

                    <div className="campaign-card-info">

                      <h3>
                        {item.title}
                      </h3>

                      <p>
                        {item.category}
                      </p>

                    </div>

                  </article>

                ))}

              </div>

            </section>

          ))}

        </div>


        {/* =====================================
            BOTTOM CATEGORY NAVIGATION
        ===================================== */}

        <nav className="campaign-category-bar">

          {/* LEFT */}

          <button
            className="campaign-nav-arrow"
            onClick={() =>
              goToCategory("COMMERCIALS")
            }
            aria-label="Previous category"
          >
            &larr;
          </button>


          {/* CATEGORY LIST */}

          <div className="campaign-category-list">

            {categories.map((category) => (

              <button
                key={category}
                type="button"
                className={`campaign-category ${category === "BRAND FILMS"
                    ? "active"
                    : ""
                  }`}
                onClick={() =>
                  goToCategory(category)
                }
              >
                {category}
              </button>

            ))}

          </div>


          {/* RIGHT */}

          <button
            className="campaign-nav-arrow"
            onClick={() =>
              goToCategory("CORPORATE FILMS")
            }
            aria-label="Next category"
          >
            &rarr;
          </button>

        </nav>

      </div>

    </main>
  );
}


export default BrandFilms;